<template>
  <el-dialog v-bind="$attrs"
             v-on="$listeners"
             title="海尔生物医疗经销商引入评估"
             append-to-body
             :close-on-click-modal="false"
             width="90%">
    <div class="h-content paddingtopcls">
      <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;margin-top: 30px;">
        <h1>引入评估</h1>
      </div>
      <!-- 页签：不同产业网络 -->
      <el-tabs v-model="activeTab" type="border-card" @tab-click="tabClick">
        <!-- ============ 页签1：国内市场（保留原 field==1/2 逻辑） ============ -->
        <el-tab-pane label="国内市场" name="guoneishichang">
          <!-- v-if 控制：只有当前激活是guoneishichang才渲染内部所有DOM（table+brupload附件） -->
          <div v-if="activeTab === 'guoneishichang'">
            <table style="border-collapse: collapse;width:100%; margin-bottom: 20px;margin-top: 20px;" cellspacing="0" border="1">
              <!-- 表头（各页签统一） -->
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="3"><img src="../../../public/assets/images/flow/agent_score.png" height="32" width="108"/></td>
                <td style="width: 180px" colspan="2" rowspan="3" class="title">海尔生物医疗经销商引入评估</td>
                <td style="width: 100px">编号：GNSCB-02-F01</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">版本：B</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">页次：1/1</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan="4" class="subheading">基础信息</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">区    域</td>
                <td style="width: 180px">{{bscUserInfoAgent.areaname}}</td>
                <td style="width: 100px">申请日期</td>
                <td style="width: 100px">{{bscUserInfoAgent.creationDate}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">公司名称</td>
                <td style="width: 180px">{{bscUserInfoAgent.username}}</td>
                <td style="width: 100px">法人代表</td>
                <td style="width: 100px">{{bscUserInfoAgent.legal}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">对接人</td>
                <td style="width: 180px">{{bscUserInfoAgent.name1}}</td>
                <td style="width: 100px">联系电话</td>
                <td style="width: 100px">{{bscUserInfoAgent.contactmobilephone}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">对阵地市（个数）</td>
                <td style="width: 180px">{{bscUserInfoAgent.againstAreaCount}}</td>
                <td style="width: 100px">对阵用户（个数）</td>
                <td style="width: 100px">{{bscUserInfoAgent.againstUserCount}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan="4" class="subheading">引入评估项目</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="subheading">评估项目</td>
                <td style="width: 180px" class="subheading">项目描述</td>
                <td style="width: 100px" class="subheading">见证资料（附件为必传项）</td>
                <td style="width: 100px" class="subheading">合格/不合格</td>
              </tr>
              <!-- 生命科学领域 -->
              <tr v-if="field==2" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">人员配置</td>
                <td style="width: 180px">员工6名以上，一线销售人员3名以上</td>
                <td style="width: 100px">提供公司缴纳社保人员数量</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.staffing" placeholder="请选择" class="select" @change="changeStaffing($event)" style="width:100px;border: none;box-shadow: none">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==2" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">公司规模</td>
                <td style="width: 180px">上年度销售业绩：A类区域≥1200万，B类区域≥1000万，C类区域≥600万</td>
                <td style="width: 100px">上年度审计表</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.scale" placeholder="请选择" @change="changeScale($event)" style="width:100px;">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==2" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">经营资质</td>
                <td style="width: 180px">临床检验分析仪器、二类6858-3、6853-4、11-01、22-14、22-15、22-16三类6854-1、22-16</td>
                <td style="width: 100px">提供营业执照、经营许可证</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.qualification" @change="changeQualification($event)" placeholder="请选择" style="width:100px">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==2" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">品牌能力</td>
                <td style="width: 180px">同行业相关产品的代理授权书或证书</td>
                <td style="width: 100px">提供同行业品牌授权文件</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.brandPower" placeholder="请选择" @change="changebrandPower($event)" style="width:100px">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==2" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">业务能力</td>
                <td style="width: 180px">近两年中标业绩证明或合同证明10份以上，或用户合同规模≥600万</td>
                <td style="width: 100px">提供合同或业绩证明文件</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.businessPower" @change="changehBusinessPower($event)" placeholder="请选择" style="width:100px">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <!-- 医疗创新领域 -->
              <tr v-if="field==1" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">人员配置</td>
                <td style="width: 180px">根据签约金额A类区域每400万配置一名专职人员，非A类区域每300万配置一人 </td>
                <td style="width: 100px">提供公司缴纳社保人员数量及区域经理确认人员配置说明</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.staffing" placeholder="请选择" class="select" @change="changeStaffing($event)" style="width:100px;border: none;box-shadow: none">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==1" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">公司规模</td>
                <td style="width: 180px">仓储库房≥30㎡</td>
                <td style="width: 100px">提供区域经理在现场的照片</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.scale" placeholder="请选择" @change="changeScale($event)" style="width:100px;">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==1" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">经营资质</td>
                <td style="width: 180px">经营范围与资质：临床检验分析仪器、二类6858-3、6853-4、11-01、22-14、22-15、22-16三类6854-1、22-16</td>
                <td style="width: 100px">提供营业执照、经营许可证</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.qualification" @change="changeQualification($event)" placeholder="请选择" style="width:100px">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==1" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">品牌能力</td>
                <td style="width: 180px">同行业相关产品的代理授权书或证书或医疗行业</td>
                <td style="width: 100px">提供同行业品牌授权文件</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.brandPower" placeholder="请选择" @change="changebrandPower($event)" style="width:100px">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-if="field==1" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">业务能力</td>
                <td style="width: 180px">市场推广商业计划书：①专职人员:日常工作占70%以上是海尔产品 ②按照年度签约规模，15%-20%安全库存 ③区域医疗器械行业展会及二级渠道推广会.每年不低于两次</td>
                <td style="width: 100px">商业计划书签字盖章文件</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent.businessPower" @change="changehBusinessPower($event)" placeholder="请选择" style="width:100px">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <!-- 结论、请示报告、确认 -->
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="subheading">结论</td>
                <td style="width: 180px" colspan="3">{{bscUserInfoAgent.conclusion}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;" v-if="!isQualified">
                <td style="width: 100px" class="subheading">申请请示报告</td>
                <td style="width: 100px" colspan="3">
                  <brupload :refid="refid" reftype="申请请示报告" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="subheading">网络运营经理确认</td>
                <td style="width: 180px">{{bscUserInfoAgent.quyuConfirm}}</td>
                <td style="width: 100px" class="subheading">省区经理确认</td>
                <td style="width: 100px" colspan="2">{{bscUserInfoAgent.daquConfirm}}</td>
              </tr>
            </table>
            <!-- ====================== 【生物医疗页签内 - 上传附件完整代码】 ====================== -->
            <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
              <h1>上传附件</h1>
            </div>
            <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">* 上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!</div>
            <div class="h-formLine weekplandetail11">
              <el-form :model="bscUserInfoAgent" label-position="right" ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                <!-- field==2 生命科学 -->
                <el-form-item v-if="field==2" label="公司缴纳社保人员数量" class="h-elformWrap-2" prop="upload1">
                  <brupload :refid="refid" reftype="公司缴纳社保人员数量" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==2" label="上年度审计表" class="h-elformWrap-2" prop="upload2">
                  <brupload :refid="refid" reftype="公司资产负债表" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==2" label="同行业品牌授权文件" class="h-elformWrap-2" prop="upload3">
                  <brupload :refid="refid" reftype="同行业品牌授权文件" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==2" label="合同或业绩证明文件" class="h-elformWrap-2" prop="upload4">
                  <brupload :refid="refid" reftype="合同或业绩证明文件" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==2" label="二类备案表" class="h-elformWrap-2" prop="upload4">
                  <brupload :refid="refid" reftype="二类备案表" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==2" label="三类医疗器械许可证" class="h-elformWrap-2" prop="upload4">
                  <brupload :refid="refid" reftype="三类医疗器械许可证" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <!-- field==1 医疗创新 -->
                <el-form-item v-if="field==1" label="公司缴纳社保人员数量" class="h-elformWrap-2" prop="upload1">
                  <brupload :refid="refid" reftype="公司缴纳社保人员数量-2" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==1" label="区域经理确认人员配置说明" class="h-elformWrap-2" prop="upload1">
                  <brupload :refid="refid" reftype="区域经理确认人员配置说明-2" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==1" label="同行业品牌授权文件" class="h-elformWrap-2" prop="upload2">
                  <brupload :refid="refid" reftype="同行业品牌授权文件-2" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==1" label="区域经理在现场照片" class="h-elformWrap-2" prop="upload3">
                  <brupload :refid="refid" reftype="区域经理在现场照片-2" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
                <el-form-item v-if="field==1" label="商业计划书签字盖章文件" class="h-elformWrap-2" prop="upload4">
                  <brupload :refid="refid" reftype="商业计划书签字盖章文件-2" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>

        <!-- ============ 页签2~7：其他产业网络（配置驱动，表头统一） ============ -->
        <el-tab-pane v-for="comp in evaluateCompanyList" :key="comp.key" :label="comp.name" :name="comp.key">
          <!-- v-if 动态判断：只渲染当前激活tab，其他tab销毁DOM，附件不会预加载 -->
          <div v-if="activeTab === comp.key">
            <table style="border-collapse: collapse;width:100%; margin-bottom: 20px;margin-top: 20px;" cellspacing="0" border="1">
              <!-- 表头（统一） -->
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="3"><img src="../../../public/assets/images/flow/agent_score.png" height="32" width="108"/></td>
                <td style="width: 180px" colspan="2" rowspan="3" class="title">海尔生物医疗经销商引入评估</td>
                <td style="width: 100px">编号：GNSCB-02-F01</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">版本：B</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">页次：1/1</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan="4" class="subheading">基础信息</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">区    域</td>
                <td style="width: 180px">{{bscUserInfoAgent.areaname}}</td>
                <td style="width: 100px">申请日期</td>
                <td style="width: 100px">{{bscUserInfoAgent.creationDate}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">公司名称</td>
                <td style="width: 180px">{{bscUserInfoAgent.username}}</td>
                <td style="width: 100px">法人代表</td>
                <td style="width: 100px">{{bscUserInfoAgent.legal}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">对接人</td>
                <td style="width: 180px">{{bscUserInfoAgent.name1}}</td>
                <td style="width: 100px">联系电话</td>
                <td style="width: 100px">{{bscUserInfoAgent.contactmobilephone}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">对阵地市（个数）</td>
                <td style="width: 180px">{{bscUserInfoAgent.againstAreaCount}}</td>
                <td style="width: 100px">对阵用户（个数）</td>
                <td style="width: 100px">{{bscUserInfoAgent.againstUserCount}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan="4" class="subheading">引入评估项目</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="subheading">评估项目</td>
                <td style="width: 180px" class="subheading">项目描述</td>
                <td style="width: 100px" class="subheading">见证资料（附件为必传项）</td>
                <td style="width: 100px" class="subheading">合格/不合格</td>
              </tr>
              <!-- 动态渲染该公司的评估项目 -->
              <tr v-for="(item,idx) in comp.items" :key="idx" style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px">{{item.name}}</td>
                <td style="width: 180px; text-align:left;">{{item.desc}}</td>
                <td style="width: 100px; text-align:left;">{{item.evidence}}</td>
                <td style="width: 100px">
                  <el-select v-model="bscUserInfoAgent[item.field]" placeholder="请选择" style="width:100px" @change="getConclusion">
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="2"></el-option>
                  </el-select>
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="subheading">结论</td>
                <td style="width: 180px" colspan="3">{{bscUserInfoAgent.conclusion}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;" v-if="!isQualified">
                <td style="width: 100px" class="subheading">申请请示报告</td>
                <td style="width: 100px" colspan="3">
                  <brupload :refid="refid" reftype="申请请示报告" uploadflag delflag :tpFlag='true' :isTpAndPdf='true' :showtime="false"></brupload>
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="subheading">网络运营经理确认</td>
                <td style="width: 180px">{{bscUserInfoAgent.quyuConfirm}}</td>
                <td style="width: 100px" class="subheading">省区经理确认</td>
                <td style="width: 100px" colspan="2">{{bscUserInfoAgent.daquConfirm}}</td>
              </tr>
            </table>
            <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
              <h1>上传附件</h1>
            </div>
            <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">* 上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!</div>
            <div class="h-formLine weekplandetail11">
              <el-form :model="bscUserInfoAgent" label-position="right" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                <el-form-item
                        v-for="(up,idx2) in comp.uploads"
                        :key="idx2"
                        :label="up.label"
                        class="h-elformWrap-2"
                        :prop="up.prop">
                  <brupload
                          :refid="refid"
                          :reftype="comp.reftypePrefix + up.reftype"
                          uploadflag
                          delflag
                          :tpFlag='true'
                          :isTpAndPdf='true'
                          :showtime="false">
                  </brupload>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>


      <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
        <h1>审核状态</h1>
      </div>
      <div class="h-formLine weekplandetail11">
        <el-form :model="bscUserInfoAgent" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
          <el-form-item label="审核状态" prop="status">
            <el-select v-model="bscUserInfoAgent.status" disabled>
              <el-option label="正常" value="1"></el-option>
              <el-option label="审核中" value="2"></el-option>
              <el-option label="驳回" value="3"></el-option>
              <el-option label="正常" value=""></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="center" style="margin-top: 30px;text-align:center;">
        <el-button class="h-btn h-formBtn h-bgblueQ" @click="saveOrUpdate">保存</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="choose1">导出Excel</el-button>
        <el-button v-if="bscUserInfoAgent.instid" class="h-btn h-formBtn h-bgblueQ" @click="genzongLiuch(bscUserInfoAgent.instid)">跟踪</el-button>
      </div>
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
  </el-dialog>
</template>


<script>
    import ss from '../../api/SystemService'
    import {genGraph} from '@/views/process/graph/Graph';

    import mxgraph from '@/views/process/graph/index';
    import agentCopyService from "../../api/loud/agent/agentCopyService";
    import updownfile from "../../utils/updownfile";
    import uploadFile from "../../api/process/account_complainUploadService";

    export default {
        data() {
            return {
                showTaskList:false,
                usercode:"",
                bscUserInfoAgent:{
                  id:"",
                  usercode:"",
                  customerName1:"",
                  staffing:"",
                  scale:"",
                  qualification:"",
                  brandPower:"",
                  businessPower:"",
                  conclusion:"",
                  daquConfirm:"",
                  quyuConfirm:"",

                  areaname:"",
                  creationDate:"",
                  username:"",
                  legal:"",
                  name1:"",
                  contactmobilephone:"",
                  showscoretable:true,
                  refid:"",
                  againstAreaCount:"",
                  againstUserCount:"",
                  field:'',
                  status:'',
                  company:''
                },
                refid: null,
                guancha:false,
                field:2,//2生命科学1医疗创新
                fieldFlag:false,
                isQualified:false,
              showhistory: null,
              instid: null,
                inst:{
                  daqu:"",
                  quyu:"",
                },
              rules: {
                  upload1:
                    [
                      {required: true, message: '请上传资料', trigger: 'blur'},
                    ],
                upload2:
                    [
                      {required: true, message: '请上传资料', trigger: 'blur'},
                    ],
                upload3:
                    [
                      {required: true, message: '请上传资料', trigger: 'blur'},
                    ],
                upload4:
                    [
                      {required: true, message: '请上传资料', trigger: 'blur'},
                    ],
              },
              oldTab: 'guoneishichang',
              activeTab: 'guoneishichang', // 默认页签
              // 其他产业网络的引入评估配置
              evaluateCompanyList: [
             /*   {
                  key: 'xueye',
                  name: '数智血液',
                  reftypePrefix: "xueye_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'总员工≥3人，专职血液产品销售≥1人', evidence:'公司缴纳社保人员数量' },
                    { field:'scale', name:'公司规模', desc:'上年度销售业绩：A类区域≥600万，B类区域≥400万，C类区域≥200万', evidence:'①公司财务报表②传统代理商代理协议③提供项目资料' },
                    { field:'qualification', name:'经营资质', desc:'经营范围与资质：二类6858‑3、6853‑4、11‑01、22‑14、22‑15、22‑16', evidence:'①提供仓库照片②营业执照' },
                    { field:'brandPower', name:'品牌能力', desc:'同行业相关产品的经销授权书或证书', evidence:'历史销售合同或供货证明' },
                    { field:'businessPower', name:'业务能力', desc:'近两年同行业中标合同5个用户以上，或单用户合同规模≥50万', evidence:'历史销售合同或供货证明' },
                  ],
                  uploads: [
                    { label:'公司缴纳社保人员数量', reftype:'公司缴纳社保人员数量', prop:'upload1' },
                    { label:'公司财务报表', reftype:'公司财务报表', prop:'upload2' },
                    { label:'传统代理商代理协议', reftype:'传统代理商代理协议', prop:'upload3' },
                    { label:'提供项目资料', reftype:'提供项目资料', prop:'upload4' },
                    { label:'仓库照片', reftype:'仓库照片', prop:'upload4' },
                    { label:'营业执照', reftype:'营业执照', prop:'upload4' },
                    { label:'历史销售合同或供货证明', reftype:'历史销售合同或供货证明', prop:'upload4' },
                  ],
                },*/
               /* {
                  key: 'sanda',
                  name: '三大',
                  reftypePrefix: "sanda_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'总员工≥3人，专职血液产品销售≥1人', evidence:'公司缴纳社保人员数量' },
                    { field:'scale', name:'公司规模', desc:'上年度销售业绩：A类区域≥600万，B类区域≥400万，C类区域≥200万', evidence:'①公司财务报表②传统代理商代理协议③提供项目资料' },
                    { field:'qualification', name:'经营资质', desc:'经营范围与资质：二类6858‑3、6853‑4、11‑01、22‑14、22‑15、22‑16', evidence:'①提供仓库照片②营业执照' },
                    { field:'brandPower', name:'品牌能力', desc:'同行业相关产品的经销授权书或证书', evidence:'历史销售合同或供货证明' },
                    { field:'businessPower', name:'业务能力', desc:'近两年同行业中标合同5个用户以上，或单用户合同规模≥50万', evidence:'历史销售合同或供货证明' },
                  ],
                  uploads: [
                    { label:'公司缴纳社保人员数量', reftype:'公司缴纳社保人员数量', prop:'upload1' },
                    { label:'公司财务报表', reftype:'公司财务报表', prop:'upload2' },
                    { label:'传统代理商代理协议', reftype:'传统代理商代理协议', prop:'upload3' },
                    { label:'提供项目资料', reftype:'提供项目资料', prop:'upload4' },
                    { label:'仓库照片', reftype:'仓库照片', prop:'upload4' },
                    { label:'营业执照', reftype:'营业执照', prop:'upload4' },
                    { label:'历史销售合同或供货证明', reftype:'历史销售合同或供货证明', prop:'upload4' },
                  ],
                },*/
                {
                  key: 'jinweixin',
                  name: '金卫信',
                  reftypePrefix: "jinweixin_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'员工人数2人以上，至少一人专职疾控渠道销售', evidence:'公司缴纳社保人员数量' },
                    { field:'scale', name:'公司规模', desc:'上年销售业绩≧50万', evidence:'提供年度审计报告或其他收入证明材料' },
                    { field:'qualification', name:'经营资质', desc:'①经营范围与资质：提供营业执照、二类医疗器械经营备案表包含6858；②资金能力：具备备货、垫资能力，首笔货款要求支付20万以上', evidence:'销售资质' },
                    { field:'brandPower', name:'品牌能力', desc:'协助组织产品推广活动，每年≧1次', evidence:'——' },
                    { field:'businessPower', name:'业务能力', desc:'①市场投入：每月提供用户拜访计划，信息漏斗反馈和订单计划；②业绩能力：近两年有疾控中心或预防接种门诊相关销售业绩≧2份，提供销售合同或见证资料', evidence:'历史销售合同或供货证明' },
                  ],
                  uploads: [
                    { label:'公司缴纳社保人员数量', reftype:'公司缴纳社保人员数量', prop:'upload1' },
                    { label:'年度审计报告或其他收入证明材料', reftype:'年度审计报告或其他收入证明材料', prop:'upload2' },
                    { label:'销售资质', reftype:'销售资质', prop:'upload3' },
                    { label:'历史销售合同或供货证明', reftype:'历史销售合同或供货证明', prop:'upload4' },
                  ],
                },
                {
                  key: 'kangsheng',
                  name: '康盛', //原耗材改名为康盛
                  reftypePrefix: "kangsheng_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'总员工≥2人，专职耗材销售≥1人', evidence:'公司缴纳社保人员数量' },
                    { field:'scale', name:'公司规模', desc:'①签约耗材代理商/白标：上年度公司总销售业绩≥200万；②海尔传统代理商销售耗材：公司为海尔传统签约代理商；③项目类经销商无特殊限制', evidence:'①公司财务报表②传统代理商代理协议③提供项目资料' },
                    { field:'qualification', name:'经营资质', desc:'①签约耗材代理商需具备耗材仓储能力；②营业执照经营范围包含对应耗材销售类目；③其他类型经销商无限制', evidence:'①提供仓库照片②营业执照' },
                    { field:'brandPower', name:'品牌能力', desc:'有销售实验室耗材、医疗耗材、生命科学产品相关经验', evidence:'历史销售合同或供货证明' },
                    { field:'businessPower', name:'业务能力', desc:'有销售实验室耗材、医疗耗材、生命科学产品相关经验', evidence:'历史销售合同或供货证明' },
                  ],
                  uploads: [
                    { label:'公司缴纳社保人员数量', reftype:'公司缴纳社保人员数量', prop:'upload1' },
                    { label:'公司财务报表', reftype:'公司财务报表', prop:'upload2' },
                    { label:'传统代理商代理协议', reftype:'传统代理商代理协议', prop:'upload3' },
                    { label:'提供项目资料', reftype:'提供项目资料', prop:'upload4' },
                    { label:'仓库照片', reftype:'仓库照片', prop:'upload4' },
                    { label:'营业执照', reftype:'营业执照', prop:'upload4' },
                    { label:'历史销售合同或供货证明', reftype:'历史销售合同或供货证明', prop:'upload4' },
                  ],
                },
                {
                  key: 'haishengjie',
                  name: '海盛杰',
                  reftypePrefix: "haishengjie_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'员工3名及以上，一线销售人员1名及以上', evidence:'个税证明或公司社保参保人数' },
                    { field:'scale', name:'公司规模', desc:'①上年度销售业绩≥100万；②项目类经销商无特殊限制', evidence:'①提供财务报表或公司年度审计报告②提供项目资料' },
                    { field:'qualification', name:'经营资质', desc:'①营业执照经营范围包含医疗器械等设备相关；②负责医疗渠道的需含二类医疗器械22‑15资质；③气体公司及oem客户对经营资质无限制', evidence:'提供营业执照、经营许可证' },
                    { field:'brandPower', name:'品牌能力', desc:'有销售低温设备、液氮生物容器、生物医疗实验室设备、低温配件及元件、低温电子仪器仪表等产品相关经验', evidence:'提供合同或业绩证明文件' },
                    { field:'businessPower', name:'业务能力', desc:'有销售低温设备、液氮生物容器、生物医疗实验室设备、低温配件及元件、低温电子仪器仪表等产品相关经验', evidence:'提供合同或业绩证明文件' },
                  ],
                  uploads: [
                    { label:'个税证明或公司社保参保人数', reftype:'个税证明或公司社保参保人数', prop:'upload1' },
                    { label:'财务报表或公司年度审计报告', reftype:'财务报表或公司年度审计报告', prop:'upload2' },
                    { label:'提供项目资料', reftype:'提供项目资料', prop:'upload3' },
                    { label:'营业执照、经营许可证', reftype:'营业执照经营许可证', prop:'upload4' },
                    { label:'合同或业绩证明文件', reftype:'合同或业绩证明文件', prop:'upload4' },
                  ],
                },
                {
                  key: 'houhong',
                  name: '厚宏',
                  reftypePrefix: "houhong_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'A类核心经销商：总员工≥6人，专职销售≥3人|B类经销商：总员工≥4人，专职销售≥2人|C类经销商：总员工≥3人，专职销售≥1人|D类经销商：总员工≥2人，专职销售≥1人', evidence:'个税证明或公司社保参保人数' },
                    { field:'scale', name:'公司规模', desc:'A类核心经销商：上年度销售业绩≥600万|B类经销商：上年度实际销售业绩＞200万元|C类经销商：上年度实际销售业绩＞50万元|D类经销商：年销售额不作考核', evidence:'A类、B类、C类经销商提供年度审计报告、财务报表或销售业绩证明；D类经销商提供基本经营情况说明或相关证明材料' },
                    { field:'qualification', name:'经营资质', desc:'①合法商事主体：营业执照经营范围包含医疗器械、自动化设备、智能设备、信息系统集成或药房自动化相关产品服务类目；公司成立1年以上，无失信被执行人、重大行政处罚、经营异常记录；②如涉及医疗器械经营，须提供相应的医疗器械经营备案凭证或经营许可证；③具备与药房自动化业务相匹配的设备周转、备件存储及售后服务场所；④资金能力：具备项目备货、垫资能力，可缴纳代理保证金或首单货款', evidence:'①提供营业执照②提供医疗器械经营备案凭证或经营许可证③提供仓库或服务场所照片④提供纳税证明或相关资金能力证明' },
                    { field:'brandPower', name:'品牌能力', desc:'具有药房自动化、智慧药房、医院药房信息化、自动化设备或医疗器械相关销售及项目实施经验', evidence:'提供合同或业绩证明文件' },
                    { field:'businessPower', name:'业务能力', desc:'A类核心经销商：承诺年度任务量及区域市场目标，制定市场推广活动和客户拜访计划；具备区域客户开发、项目跟进和落地服务能力；近两年相关中标业绩证明或合同证明≥5份，或项目合作金额原则上≥200万元|B类经销商：承诺年度任务量及区域市场目标，制定市场推广活动和客户拜访计划；具备区域客户开发、项目跟进和落地服务能力；近两年相关中标业绩证明或合同证明≥3份，或项目合作金额原则上≥100万元|C类经销商：承诺具体项目目标，制定项目推广和客户拜访计划；具备目标医院开发、项目跟进和落地服务能力；近两年相关中标业绩证明或合同证明≥1份，或项目合作金额原则上≥50万元|D类经销商：具备明确的目标医院或具体项目，能够制定项目推进及客户拜访计划；历史合同不作硬性要求，项目合作金额根据具体项目需求评估确定|合规管理：各类经销商均须承诺不窜货、不乱价，遵守厂家价格体系及渠道管理规定', evidence:'提供合同、中标证明、供货证明、项目合作资料、目标医院证明及市场推广计划' },
                  ],
                  uploads: [
                    { label:'个税证明或公司社保参保人数', reftype:'个税证明或公司社保参保人数', prop:'upload1' },
                    { label:'年度审计报告/财务报表/销售业绩证明', reftype:'年度审计报告或财务报表或销售业绩证明', prop:'upload2' },
                    { label:'基本经营情况说明或相关证明材料', reftype:'基本经营情况说明或相关证明材料', prop:'upload3' },
                    { label:'营业执照', reftype:'营业执照', prop:'upload4' },
                    { label:'医疗器械经营备案凭证或经营许可证', reftype:'医疗器械经营备案凭证或经营许可证', prop:'upload4' },
                    { label:'仓库或服务场所照片', reftype:'仓库或服务场所照片', prop:'upload4' },
                    { label:'纳税证明或相关资金能力证明', reftype:'纳税证明或相关资金能力证明', prop:'upload4' },
                    { label:'合同、中标证明、供货证明、项目合作资料等', reftype:'合同中标证明供货证明项目合作资料', prop:'upload4' },
                  ],
                },
                {
                  key: 'yuanxi',
                  name: '元析',
                  reftypePrefix: "yuanxi_",
                  items: [
                    { field:'staffing', name:'人员配置', desc:'总员工≥2人，有销售人员，人员有生命科学、分析化学等相关教育背景优先', evidence:'公司缴纳社保人员数量' },
                    { field:'scale', name:'公司规模', desc:'上年销售业绩＞100万', evidence:'提供年度审计报告或其他收入证明材料' },
                    { field:'qualification', name:'经营资质', desc:'合法商事主体：公司需成立1年以上。无失信被执行人、重大行政处罚、经营异常记录', evidence:'供营业执照、企查查/天眼查失信' },
                    { field:'brandPower', name:'品牌能力', desc:'①有分析仪器、科研仪器等相关销售经验；②有政府实验室、高校科研院所、第三方检测、环境监测、食品制药工厂等终端客户资源', evidence:'招投标中标通知书、政府采购网中标信息、市场推广案例' },
                    { field:'businessPower', name:'业务能力', desc:'合规管理：承诺不窜货、不乱价，遵守厂家价格体系', evidence:'历史销售合同或供货证明（非强制，有则优先）' },
                  ],
                  uploads: [
                    { label:'公司缴纳社保人员数量', reftype:'公司缴纳社保人员数量', prop:'upload1' },
                    { label:'年度审计报告或其他收入证明材料', reftype:'年度审计报告或其他收入证明材料', prop:'upload2' },
                    { label:'营业执照', reftype:'营业执照', prop:'upload3' },
                    { label:'企查查/天眼查失信', reftype:'企查查或天眼查失信', prop:'upload4' },
                    { label:'招投标中标通知书、政府采购网中标信息、市场推广案例', reftype:'招投标中标通知书或政府采购网中标信息', prop:'upload4' },
                    { label:'历史销售合同或供货证明', reftype:'历史销售合同或供货证明', prop:'upload4' },
                  ],
                },
              ],

            };
        },

        computed: {
            UsercodeInfo:function(){
              return this.usercodeInfo;
            },
            Instid:function(){
              return this.instid;
            },
        },
        props: {
          usercodeInfo: {
            type: String,
          },
          instid: {
            type: String,
          },
        },

        mounted() {
          // 例如默认打开第一个页签
          this.activeTab = 'guoneishichang'
          this.handleTabChange('guoneishichang') // 手动调用，实现和点击一样逻辑

          ss.SignService.getScore(this.UsercodeInfo,'guoneishichang').then(res => {
            console.log("11111",res)
            this.bscUserInfoAgent.id= res.obj.idSco;
            this.bscUserInfoAgent.usercode= res.obj.usercodeInfo;
            this.bscUserInfoAgent.customerName1= res.obj.customerName1Bas;
            this.bscUserInfoAgent.staffing= res.obj.staffingSco;
            this.bscUserInfoAgent.scale= res.obj.scaleSco;
            this.bscUserInfoAgent.qualification= res.obj.qualificationSco;
            this.bscUserInfoAgent.brandPower= res.obj.brandPowerSco;
            this.bscUserInfoAgent.businessPower= res.obj.businessPowerSco;
            this.bscUserInfoAgent.conclusion= res.obj.conclusionSco;
            this.bscUserInfoAgent.daquConfirm= res.obj.daquConfirmSco;
            this.bscUserInfoAgent.quyuConfirm= res.obj.quyuConfirmSco;
            this.bscUserInfoAgent.status= res.obj.statusSco;
            this.bscUserInfoAgent.instid= res.obj.instidSco;
            this.bscUserInfoAgent.company= res.obj.companySco;

            this.bscUserInfoAgent.areaname= res.obj.areanameInfo;
            this.bscUserInfoAgent.creationDate= res.obj.creationDateBas;
            this.bscUserInfoAgent.username= res.obj.usernameInfo;
            this.bscUserInfoAgent.legal= res.obj.legalBas;
            this.bscUserInfoAgent.name1= res.obj.name1Bas;
            this.bscUserInfoAgent.contactmobilephone= res.obj.contactmobilephoneBas;
            this.refid = res.obj.fileidInfo;
            this.bscUserInfoAgent.refid = res.obj.fileidInfo;
            this.bscUserInfoAgent.field = res.obj.fieldSco;

            if(res.obj.staffingSco == null || res.obj.staffingSco == ''|| res.obj.staffingSco == undefined){
                this.getField();
            }
            if(res.obj.fieldSco != null && res.obj.fieldSco != ''){
                this.field = res.obj.fieldSco;
            }

            this.getConclusion();
          })
          let query={
            agentCode:this.UsercodeInfo,
          }
          ss.annualTargetApi.selectUserByAgent(query).then(res =>{
            this.bscUserInfoAgent.againstAreaCount = res.obj;
          })
          ss.annualTargetApi.selectUserByUser(query).then(res =>{
            this.bscUserInfoAgent.againstUserCount = res.obj;
          })
        },
        methods: {
          ok(){
            this.usercode = this.UsercodeInfo
          },
          changeStaffing(res){
            this.bscUserInfoAgent.staffing = res;
            this.getConclusion();
          },
          changeScale(res){
            this.bscUserInfoAgent.scale = res;
            this.getConclusion();
          },
          changeQualification(res){
            this.bscUserInfoAgent.qualification = res;
            this.getConclusion();
          },
          changebrandPower(res){
            this.bscUserInfoAgent.brandPower = res;
            this.getConclusion();
          },
          changehBusinessPower(res){
            this.bscUserInfoAgent.businessPower = res;
            this.getConclusion();
          },
          changeCompany(res){
            this.handleTabChange(res)
          },
// 抽公共方法，代码切换tab也手动调用
          handleTabChange(res){
            console.log('切换tab，选中key：', res);

          },
          tabClick(tab) {
            console.log('切换tab，当前选中name：', tab.name)
            // 这里写你原来change里面的业务逻辑
            const newName = tab.name
            if(newName !== this.oldTab){
              console.log('真正切换tab', newName)
              this.bscUserInfoAgent.company = newName;
              this.oldTab = newName
              // 【关键】切换完成后，重新计算结论和isQualified
              this.$nextTick(()=>{
                //重新加载数据
                ss.SignService.getScore(this.UsercodeInfo,newName).then(res => {
                  console.log("11111",res)
                  this.bscUserInfoAgent.id= res.obj.idSco;
                  this.bscUserInfoAgent.usercode= res.obj.usercodeInfo;
                  this.bscUserInfoAgent.customerName1= res.obj.customerName1Bas;
                  this.bscUserInfoAgent.staffing= res.obj.staffingSco;
                  this.bscUserInfoAgent.scale= res.obj.scaleSco;
                  this.bscUserInfoAgent.qualification= res.obj.qualificationSco;
                  this.bscUserInfoAgent.brandPower= res.obj.brandPowerSco;
                  this.bscUserInfoAgent.businessPower= res.obj.businessPowerSco;
                  this.bscUserInfoAgent.conclusion= res.obj.conclusionSco;
                  this.bscUserInfoAgent.daquConfirm= res.obj.daquConfirmSco;
                  this.bscUserInfoAgent.quyuConfirm= res.obj.quyuConfirmSco;
                  this.bscUserInfoAgent.status= res.obj.statusSco;
                  this.bscUserInfoAgent.instid= res.obj.instidSco;

                  this.bscUserInfoAgent.areaname= res.obj.areanameInfo;
                  this.bscUserInfoAgent.creationDate= res.obj.creationDateBas;
                  this.bscUserInfoAgent.username= res.obj.usernameInfo;
                  this.bscUserInfoAgent.legal= res.obj.legalBas;
                  this.bscUserInfoAgent.name1= res.obj.name1Bas;
                  this.bscUserInfoAgent.contactmobilephone= res.obj.contactmobilephoneBas;
                  this.refid = res.obj.fileidInfo;
                  this.bscUserInfoAgent.refid = res.obj.fileidInfo;
                  this.bscUserInfoAgent.field = res.obj.fieldSco;

                  if(res.obj.staffingSco == null || res.obj.staffingSco == ''|| res.obj.staffingSco == undefined){
                    this.getField();
                  }
                  if(res.obj.fieldSco != null && res.obj.fieldSco != ''){
                    this.field = res.obj.fieldSco;
                  }

                  this.getConclusion();
                })
              })
            }
          },

          getConclusion(){
            if(this.bscUserInfoAgent.staffing == 1 &&
                this.bscUserInfoAgent.scale == 1 &&
                this.bscUserInfoAgent.qualification == 1 &&
                this.bscUserInfoAgent.brandPower == 1 &&
                this.bscUserInfoAgent.businessPower == 1
            ){
              this.bscUserInfoAgent.conclusion = "合格";
              this.isQualified = true;
            }else {
              this.bscUserInfoAgent.conclusion = "不合格";
              this.isQualified = false;
            }
          },
          saveOrUpdate(){
            if(this.bscUserInfoAgent.staffing == null || this.bscUserInfoAgent.staffing == "" ||
                this.bscUserInfoAgent.scale == null || this.bscUserInfoAgent.scale == "" ||
                this.bscUserInfoAgent.qualification == null ||   this.bscUserInfoAgent.qualification == "" ||
                this.bscUserInfoAgent.brandPower == null || this.bscUserInfoAgent.brandPower == "" ||
                this.bscUserInfoAgent.businessPower == null ||this.bscUserInfoAgent.businessPower == ""){
              this.$message({
                message: "请完善评审项目!",
                type: 'error'
              });
              return;
            }
            this.bscUserInfoAgent.field = this.field;
            this.bscUserInfoAgent.customerName1 = this.bscUserInfoAgent.username;
            let query = this.bscUserInfoAgent;
            ss.SignService.updateByIdScore(query).then(res =>{
              if(res.f){
                this.$message({
                  message: "保存成功!",
                  type: 'success'
                });
              }
              this.bscUserInfoAgent.showscoretable = false;
              this.$emit('choseObj', this.bscUserInfoAgent)
            })
            this.getConclusion();
          },
          //获取当前登录人领域
          getField(){
            //默认生命科学领域
            this.field = 2;
     /*       if (this.$store.getters.hasRole('swyl_quyujl')) {
              ss.SignService.getField().then(res =>{
                console.log('res',res);
                if(res.msg.code == "L1"){
                  this.field = 1;
                }else if(res.msg.code == "L2"){
                  this.field = 2;
                }else {
                  this.$message({
                    message: "未查询到对应领域,请联系管理员!",
                    type: 'error'
                  });
                }
              })
            }*/
          },
          cheakFile(){
            console.log("1111")
          },
          choose1() {
            updownfile.down('/api/swyl/v1/agent/bscUserInfoAgent/getExcel',this.bscUserInfoAgent,"post");
          },
          beforeUpload(file){
            const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
            const isLt5M = file.size / 1024 / 1024 < 5;
            console.log(isFile,file.type)

            if (!isFile) {
              this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
              return false;
            }
            if (!isLt5M) {
              this.$message.error('上传文件的大小不能超过 5M!');
              return false;
            }
          },
          //跟踪
          genzongLiuch(instid) {
            this.instid = instid;

            this.showhistory = true;
          },
        }
    }
</script>
<style>
    .showflowDialogcls .el-dialog__body{
        padding-top: 0px!important;
    }
    ::v-deep  .select{
      border: none;
      box-shadow: none;
    }
    .weekplandetail11 .h-formbLine .el-form-item__label {
      width: 39%;
    }

    .weekplandetail11 .h-formbLine .el-form-item__content {
      width: 61%;
    }
</style>
<style scoped>
    #graphContainer {
        overflow: hidden;
        width: 100%;
        min-height: 100px;
        padding-bottom: 20px;
        background: url('../../assets/images/flow/grid.gif');;
        border-radius: 4px;
    }
    .h-content {
        padding: 0rem 0.1rem 0 0.1rem;
    }
    .h-row .h-rowIn {
      padding: 0px !important;
    }
    .showTaskListClass {
        width:400px;
        border:1px solid #ccc;
        position: fixed;
        color:#333;
        font-size: 12px;
        z-index: 9999;
        background-color: rgba(255,255,255,0.8);
        border: 1px solid #c2c2c2;
        border-radius: 5px;
        padding: 12px;
    }
    .showTaskListClass  table {
          border-collapse: collapse;
          margin: 0 auto;
          text-align: center;
      }
    .showTaskListClass  table thead th{
        background-color: #57aefe;
        text-align: center;
        color:#fff;
    }
    .showTaskListClass table td, table th
    {
        border: 1px solid #cad9ea;
        color: #666;
        height: 30px;
    }
    .showTaskListClass table tr:nth-child(odd)
    {
        background: #fff;
    }
    .showTaskListClass table tr:nth-child(even)
    {
        background: #F5FAFA;
    }
    .outTimeline {
        background-color: #fcfcfc;
        border-radius: 10px;
    }
    .title{
        font-size: 20px;
        font-weight:bold;
    }
    .subheading{
      font-weight:bold;
    }

</style>

